import { useTranslator } from "@eo-locale/react";

import { setImageDetails } from "@/redux/features/place-form/slice";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { FormControl, FormLabel, ImageEditor } from "@/storybook-components";

const ImageQuesion = ({ question }: { question: any }) => {
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();

  const { imageDetails } = useAppSelector((state) => state.placesForm);
  const { isEditMode } = useAppSelector((state) => state.placesMarkerSlice);

  const handleImageChange = async (imagePath: string) => {
    await dispatch(setImageDetails({ ...imageDetails, fileUrl: imagePath }));
    setTimeout(() => {
      document.getElementById("update-image")?.focus();
    }, 500);
  };

  const getFileDetails = (data) => {
    const details = {
      type: data.type,
      name: data.name,
      size: data.size,
      questionId: question.id
    };

    dispatch(setImageDetails({ ...imageDetails, ...details }));
  };

  return (
    <FormControl mt={6} key={isEditMode ? "edit" : "create"}>
      {imageDetails.fileUrl && (
        <FormLabel mb={3}>{translate("places.pin.image")}</FormLabel>
      )}
      <ImageEditor
        keepOriginalImageToBeCropped
        onCropComplete={handleImageChange}
        existingImageUrl={imageDetails.fileUrl}
        onDelete={() => {
          dispatch(
            setImageDetails({
              question: question.id,
              fileUrl: "",
              type: "",
              name: "",
              size: 0
            })
          );
        }}
        renderAsButton={true}
        getFileDetails={getFileDetails}
      />
    </FormControl>
  );
};

export default ImageQuesion;
